import { OEText } from '@openeducation/oe-rn-components';
import { currentLiveClassLessonAtom } from '@openeducation/oe-rn-jotai-atoms';
import { FREE_FORM_LESSON_UUID } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import { useAtomValue } from 'jotai';
import * as React from 'react';

import { LiveClassLessonDownloadButton } from '../../atoms/live-class-lesson-download-button/live-class-lesson-download-button';

export const PCFeedbackFormReadOnly = () => {
  const liveClassLesson = useAtomValue(currentLiveClassLessonAtom);
  if (!liveClassLesson?.displayName) return null;

  const isNotFreeFormTopic = liveClassLesson?.uuid !== FREE_FORM_LESSON_UUID;

  return (
    <Container>
      <Label fontSize={20} fontType="bold">
        {liveClassLesson?.displayName}
      </Label>
      {isNotFreeFormTopic && liveClassLesson?.lessonMaterialUrl && (
        <LiveClassLessonDownloadButton
          url={liveClassLesson?.lessonMaterialUrl}
        />
      )}
    </Container>
  );
};

const Label = styled(OEText)`
  margin-right: 24px;
  margin-top: 4px;
`;

const Container = styled.View`
  justify-content: center;
  flex-direction: row;
  margin-top: 40px;
`;

export default PCFeedbackFormReadOnly;
